/**
 * one day is about 50px wide
 * - if the screen is large enough to display 31 days (full month), allow to display a max of 31 days
 * - if the screen is too small to display the default of 20 days, only allow to select what can fit in the screen
 * - otherwise, allow the default value of 20 days
 */

/**
 * approx. width in pixels of a day
 */
export const UI_DAY_CELL_WIDTH = 50;

/**
 * width in pixels of the caption column in regular view
 */
export const UI_CAPTION_COLUMN_WIDTH = 220;

/**
 * default number of days that should be displayed if the window width allows it
 */
export const UI_DEFAULT_DAYS_VIEW = 20;

/**
 * max number of days that can be displayed in "extended view" if the window width allows it
 */
export const UI_EXTENDED_MAX_DAYS_VIEW = 31;
